module.exports = __webpack_public_path__ + "static/media/didi_playing_baja_body.f34d53fa.gif";